import { Route, Routes } from 'react-router-dom';
import { ROUTES } from './routes';

export const Router = () => (
  <Routes>
    <Route {...ROUTES.home} />
    <Route {...ROUTES.lender} />
    <Route {...ROUTES.firms} />
    <Route {...ROUTES.brokers} />
    <Route {...ROUTES.procurationFees} />
    <Route {...ROUTES.products} />
    <Route {...ROUTES.rates} />
    <Route {...ROUTES.exchangeRates} />
    <Route {...ROUTES.fees} />
    <Route {...ROUTES.erc} />
    <Route {...ROUTES.imports} />
    <Route {...ROUTES.exportTemplates} />
    <Route {...ROUTES.changeRequests} />
    <Route {...ROUTES.exclusiveProducts} />
    <Route {...ROUTES.notFound} />
  </Routes>
);
